import LegalLayout, { LP, LL, LMail } from "@/components/LegalLayout";

const SECTIONS = [
  {
    heading: "1. Data controller",
    body: (
      <LP>
        The data controller for this website is <strong className="text-white">4EMPIRE</strong> —
        reachable at <LMail /> or on WhatsApp at +351 926 856 052 (registered address: to be added).
      </LP>
    ),
  },
  {
    heading: "2. Data we collect",
    body: (
      <>
        <LP>When you use this website, we may collect the following data, always provided by you:</LP>
        <LL
          items={[
            "Project enquiry form: full name, professional email, company, website (optional), service requested, estimated budget (optional) and project description.",
            "Call booking: name, email, preferred date and time, subject and notes — this information is sent by you directly to our WhatsApp when you confirm.",
            "Technical data: standard connection logs required for the operation and security of the hosting infrastructure.",
          ]}
        />
      </>
    ),
  },
  {
    heading: "3. Why we use your data",
    body: (
      <>
        <LP>Your data is used exclusively to:</LP>
        <LL
          items={[
            "Respond to your enquiries and project requests",
            "Prepare proposals and quotes",
            "Manage our pre-contractual and commercial relationship with you",
            "Ensure the security and proper functioning of the website",
          ]}
        />
        <LP>
          The legal bases are the performance of pre-contractual measures (Art. 6.1.b GDPR) and our
          legitimate interest in running and promoting our business (Art. 6.1.f GDPR).
        </LP>
      </>
    ),
  },
  {
    heading: "4. Who receives your data",
    body: (
      <>
        <LP>
          Your data is accessible only to the 4EMPIRE team. We rely on a limited number of service
          providers acting as processors:
        </LP>
        <LL
          items={[
            "Hosting provider (cloud infrastructure operating this website)",
            "Transactional email provider (delivery of enquiry notifications)",
            "WhatsApp (Meta Platforms), only when you choose to contact us or confirm a booking through it — WhatsApp applies its own privacy policy",
          ]}
        />
        <LP>We never sell your personal data to third parties.</LP>
      </>
    ),
  },
  {
    heading: "5. How long we keep it",
    body: (
      <LP>
        Enquiry data is kept for the duration of our exchanges and, if no contract follows, for a
        maximum of 24 months after our last contact. It is then deleted or anonymised.
      </LP>
    ),
  },
  {
    heading: "6. Your rights",
    body: (
      <>
        <LP>
          Under the GDPR, you have the right to access, rectify, erase, restrict or object to the
          processing of your personal data, as well as the right to data portability.
        </LP>
        <LP>
          To exercise any of these rights, write to us at <LMail />. You also have the right to
          lodge a complaint with your national data protection authority.
        </LP>
      </>
    ),
  },
  {
    heading: "7. Security & automated decisions",
    body: (
      <LP>
        We apply reasonable technical and organisational measures to protect your data. This website
        does not carry out any automated decision-making or profiling based on your personal data.
      </LP>
    ),
  },
  {
    heading: "8. Changes to this policy",
    body: (
      <LP>
        This privacy policy may be updated to reflect changes in our practices or legal
        requirements. The version published on this page is the one currently in force.
      </LP>
    ),
  },
];

export default function PrivacyPolicy() {
  return (
    <LegalLayout
      testid="privacy-policy"
      title="Privacy"
      accent="Policy."
      description="Last updated: October 2026. How 4EMPIRE collects, uses and protects your personal data (GDPR)."
      sections={SECTIONS}
    />
  );
}
